<template>
  <ul
    v-if="hasLinks"
    class="menus">
    <li
      v-for="(link, key) in links"
      :key="key"
      class="menus__item">
      <new-window-anchor
        v-if="link.isTargetBlank"
        v-bind="link"
        class="link"/>
      <right-angle-anchor
        v-else
        v-bind="link"
        class="link"/>
    </li>
  </ul>
</template>

<script>
import RightAngleAnchor from '@/mikan/_shared/components/molecules/RightAngleAnchor.vue';
import NewWindowAnchor from '@/mikan/_shared/components/molecules/NewWindowAnchor.vue';

export default {
  components: {
    RightAngleAnchor,
    NewWindowAnchor,
  },
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasLinks() {
      return Array.isArray(this.links) && this.links.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.menus {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &__item {
    font-size: $size-s;

    &:nth-child(n + 2) {
      margin-left: 20px;
    }
  }
}
</style>
